<div class="col-12 flex flex-wrap">
  <div class="w-full surface-section px-4 md:px-6 lg:px-8">
    <label class="w-full text-900 text-4xl">Annunci di lavoro</label>
  </div>
  <div class="w-full flex flex-wrap px-4 py-3 md:px-6 lg:px-8 ">

    <p-accordion [activeIndex]="0" [styleClass]="'primary'">
      <p-accordionTab header="Filtri di ricerca">
        <div class="col-12 flex flex-wrap">
          <div class="col-12 block">
            <input type="text"
                   pInputText
                   placeholder="cosa cerchi"
                   name="cosa cerchi"
                   [(ngModel)]="filtriAnnunciObj.RicercaLibera"
                   class="w-full"
                   (ngModelChange)="filtriAnnunciObj.RicercaLibera = $event.toUpperCase()"
                   [pStyleClass]="'w-full'">
          </div>
          <div class="col-12 lg:col-4 block">
            <p-autoComplete
              [(ngModel)]="RegioneSelezionata"
              [suggestions]="lstRegione"
              [dropdown]="true"
              name="task"
              placeholder=" -- regione -- "
              field="RegioneNome"
              [styleClass]="'w-full'"
              (completeMethod)="getRegione($event)"
              name="task"></p-autoComplete>
          </div>
          <div class="col-12 lg:col-4 block">
            <p-autoComplete
              [(ngModel)]="ProvinciaSelezionata"
              [suggestions]="lstProvincia"
              [dropdown]="true"
              placeholder=" -- provincia -- "
              name="task"
              [styleClass]="'w-full'"
              field="ProvinciaNome"
              (completeMethod)="getProvincia($event)"
              name="task"></p-autoComplete>
          </div>
          <div class="col-12 lg:col-4 block">
            <p-autoComplete
              [(ngModel)]="comuneResidenzaSelezionato"
              [suggestions]="comuniList"
              [dropdown]="true"
              [styleClass]="'w-full'"
              placeholder=" -- comune -- "
              field="ComuneDescrizione"
              name="task"
              (completeMethod)="getComuniAutoComplete($event)"></p-autoComplete>
          </div>
          <div class="col-12 lg:col-4 block">
            <p-autoComplete
              [(ngModel)]="SettoreSelezionato"
              [suggestions]="lstSettori"
              [dropdown]="true"
              placeholder=" -- settore -- "
              [styleClass]="'w-full'"
              field="Settore"
              (completeMethod)="getSettori($event)"
              name="task"
            ></p-autoComplete>
          </div>
<!--          <div class="col-4 block">-->
<!--            <p-autoComplete-->
<!--              [(ngModel)]="LavoroDesiderato"-->
<!--              [suggestions]="taskList"-->
<!--              placeholder=" &#45;&#45; mansione &#45;&#45; "-->
<!--              [styleClass]="'w-full'"-->
<!--              field="MansioneDesc"-->
<!--              (completeMethod)="getMansioni($event)"-->
<!--              name="task"></p-autoComplete>-->
<!--          </div>-->

          <div class="col-12 lg:col-4 block">
            <p-autoComplete
              [(ngModel)]="TipoContrattoSelezionato"
              [suggestions]="lstTipoContratto"
              [styleClass]="'w-full'"
              [dropdown]="true"
              placeholder=" -- tipo contratto -- "
              field="TipoContrattoFiltro"
              (completeMethod)="getTipoContratto($event)"
              name="task"
            ></p-autoComplete>
          </div>
          <div class="col-12 lg:col-4 block">
            <p-autoComplete
              [(ngModel)]="TipoOrarioSelezionato"
              [styleClass]="'w-full'"
              [suggestions]="lstTipoOrari"
              [dropdown]="true"
              placeholder=" -- orario -- "
              field="Value"
              (completeMethod)="getOrarioPreferenze($event)"
              name="task"
            ></p-autoComplete>
          </div>
        </div>
        <div class="w-full flex flex-wrap ">
          <div class="col-4 flex justify-content-end" >
            <button pButton pRipple label="Cerca" class="mt-2 w-full p-button-rounded" (click)="getAnnunciFiltrati(null)"></button>
          </div>
          <div class="col-4 flex justify-content-end" >
            <button pButton pRipple label="Pulisci filtri" class="mt-2 w-full p-button-rounded p-button-secondary" (click)="clearFilter()"></button>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>

   <div class ="col-12 pl-2 pr-2 flex flex-wrap py-4 justify-content-center">
        <p-table [value]="commessaAnnuncio"
                 [styleClass]="'primary'"
                 [tableStyle]="{ 'min-width': '10rem' }"
                 [paginator]="true"
                 [rows]="10"
                 [lazy]="true"
                 (onLazyLoad)="getAnnunciFiltrati($event)"
                 paginatorDropdownAppendTo="body"
                 [scrollable]="true"
                 [totalRecords]="totalAnnunci"
                 currentPageReportTemplate="Elementi totali : {totalRecords}"
                 [rowsPerPageOptions]="[10, 25, 50]">
            <ng-template pTemplate="header">
              <tr>
                <th class="w-2 bg-primary">Titolo</th>
                <th class="w-1 bg-primary">Provincia</th>
                <th class="w-1 bg-primary">Luogo</th>
                <th class="w-5 bg-primary d-none-mobile">Descrizione</th>
                <th class="w-1 bg-primary d-none-mobile">Tipo Contratto</th>
                <th class="w-1 bg-primary d-none-mobile">Orario</th>
                <th class="w-1 bg-primary d-none-mobile">Data Pubblicazione</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-record>
                <tr class="cursor-pointer" (click)="showDetails(record.IdCommessaAnnuncio,false) ">
                  <td class ="w-2">{{record.Titolo}}</td>
                  <td class ="w-1"> {{record.ProvinciaNome}}</td>
                  <td class ="w-1">{{record.Luogo}}</td>
                  <td class ="w-5 d-none-mobile">{{record.Anteprima}}</td>
                  <td class ="w-1 d-none-mobile">{{record.TipoContratto}}</td>
                  <td class ="w-1 d-none-mobile">{{record.OrarioDesc}}</td>
                  <td class ="w-1 d-none-mobile">{{record.DataPubblicazioneStr}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="12">Nessun Annuncio</td>
                </tr>
              </ng-template>
          </p-table>
    </div>
  </div>
</div>

<p-dialog [header]="headerDetailsDialog" [(visible)]="showDetailsDialog" [modal]="true" (onHide)="onhideModal()"
          [draggable]="false" [resizable]="false" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}">

  <app-details [jobPostId]="jobPostSelected.IdCommessaAnnuncio" [jobPostStr]="jobPostSelected.IdCommessaAnnuncioEnc" *ngIf="jobPostSelected.IdCommessaAnnuncio > 0 || jobPostSelected.IdCommessaAnnuncioEnc != ''"
               [showBtnCandidate]="true"
               (close)="closeModal($event)">
  </app-details>
</p-dialog>
